import { Divider, Flex, FormControl, Grid, Image, ModalBody, ModalHeader, Text, Box, ModalCloseButton, Button, Checkbox, FormLabel, Select, Input } from "@chakra-ui/react";
import MyDiv from "./loiCard.style";
import { AlertCard, CustomToast } from "../../../../../components";
import ArrowRight from "../../../../../assets/images/ArrowIcon.svg";
import SuccessAnimation from "../../../../../assets/lottie/Success.json";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { HrlenseInput } from "../../../../../components/Input/Input";
import { Controller, Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ILoi, schema } from "./modal";
import { Dropdown } from "../../../../../components/DropDown/DropDown";
import { useFetch, websiteUrl } from "../../../../../hooks/useFetch";
import { format } from "date-fns/format";
interface LOICardProps {
    onClose: () => void;
    candidateDetail: any;
    interviewResult: number;
    reload: boolean;
    setReload: React.Dispatch<React.SetStateAction<boolean>>;
}
const LOICard = ({ onClose, candidateDetail, interviewResult, reload, setReload }: LOICardProps) => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [employementType, setEmploymentType] = useState<any[]>([]);
    const [shiftType, setShiftType] = useState<any[]>([]);
    const [loiContent, setLoiContent] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [benfits, setBenfits] = useState<any | null>(null);
    const [salaryRule, setSalaryRule] = useState<any>(null);
    const [includePF, setIncludePF] = useState(true);
    const [includeESIC, setIncludeESIC] = useState(true);
    const [salarySlabRule, setSalarySlabRule] = useState<any | null>(null);

    const [alertConfig, setAlertConfig] = useState<{ description: string; colorScheme?: string; onConfirm?: () => void; } | null>(null);

    const { handleSubmit, control, formState: { errors }, watch, setValue } = useForm<ILoi>({
        resolver: yupResolver(schema) as Resolver<ILoi>,
        defaultValues: { employement_Type: "EMPLOYEE", intern_Payment_Type: "", },
        mode: "onBlur",
        shouldUnregister: true
    });

    const getCurrentSalaryRule = async (employementType: string, internType?: string) => {
        const params = new URLSearchParams({
            branchId: String(candidateDetail.branch_Id),
            departmentId: String(candidateDetail.department_Id),
            employementType: employementType,
            internPaymentType: employementType === "INTERN" ? internType ?? "" : "",
        });
        return await fetchApi("SalaryCalculationSettings/rules", "GET", "", params.toString());
    };


    const sendLoi = async (data: ILoi) => {
        setLoading(true);

        const currentRule = await getCurrentSalaryRule(data?.employement_Type ?? "EMPLOYEE", data.intern_Payment_Type);

        if (!candidateDetail) {
            addToast({ message: "Candidate details not found.", status: "error" });
            return;
        }

        if (data.employement_Type === "EMPLOYEE" && data.offered_Salary && data.offered_Salary < Number(currentRule?.min_Gross_Salary)) {
            addToast({ status: "error", message: `Minimum gross salary for Employee is ₹${currentRule?.min_Gross_Salary}`, });
            setLoading(false);
            return;
        }

        const payload = {
            Candidate_Id: candidateDetail.id,
            Selection_Term: data.selection_Term,
            Offered_Salary: data.offered_Salary ?? 0,
            Date_Of_Joining: format(data.date_Of_joining, 'yyyy-MM-dd'),
            Shift_type: data.shift_type,
            Subject: data.subject,
            Loi: loiContent,
            Interview_Result: interviewResult,
            employement_Type: data.employement_Type,
            intern_Payment_Type: data.intern_Payment_Type || "",
            Basic_Salary: data.basicSalary ?? 0,
            Basic_Salary_For_PF: data.basicSalaryForPf ?? data.basicSalary ?? 0,
            includePF: includePF,
            IncludeESIC: includeESIC,
            Employee_PF: data.employeePF ?? 0,
            Employer_PF: data.employerPF ?? 0,
            Esic_Applicable: data.employeePF !== 0 ? true : false,
            Esic_Employee: data.esicEmployee ?? 0,
            Esic_Employer: data.esicEmployer ?? 0,
            Meal_Allowance_Applied: !!data.mealAllowance,
            Meal_Allowance_Amount: data.mealAllowance ? benfits?.meal_Allowance ?? 0 : 0,
            Transport_Allowance_Applied: !!data.transportAllowance,
            Transport_Allowance_Amount: data.transportAllowance ? benfits?.transportation_Allowance ?? 0 : 0,
            Health_Insurance_Applied: !!data.healthInsurance,
            Health_Insurance_Amount: data.healthInsurance ? benfits?.health_Insurance_Coverage ?? 0 : 0,
            Monthly_CTC: data.monthlyCTC ?? 0,
            Annual_CTC: data.annualCTC ?? 0,
            Net_Take_Home_Salary: data.netTakeHomeSalary ?? 0,
            Hra: data.hra,
            Conveyance: data.conveyance,
        };

        const response = await fetchApi("Candidate/CandidateSelection", "POST", payload, "", "")
        if (response) {
            addToast({ message: "Loi send successfully", status: "success" })
            setIsSuccess(true);
            setReload(!reload);
            onClose();
            setTimeout(() => { setIsSuccess(false); }, 1000);
        }
        setLoading(false);
    }

    const LoadEmploymentType = async () => {
        const res = await fetchApi("RecruitmentMaster/employmentType", "GET", null, "");
        if (res) setEmploymentType(res);
    };
    const LoadShiftType = async () => {
        const res = await fetchApi("Dropdown/shift", "GET", null, "");
        if (res) setShiftType(res);
    };

    const employement_Type = watch("employement_Type");
    const intern_Payment_Type = watch("intern_Payment_Type");
    const isIntern = employement_Type === "INTERN";

    const loadRules = async () => {
        if (!candidateDetail) return;
        if (isIntern && !intern_Payment_Type) {
            setSalaryRule(null);
            return;
        }
        resetSalaryCalculation();
        const params = new URLSearchParams({
            branchId: String(candidateDetail.branch_Id),
            departmentId: String(candidateDetail.department_Id),
            employementType: isIntern ? "INTERN" : "EMPLOYEE",
            internPaymentType: isIntern ? intern_Payment_Type === "PAID" ? "PAID" : "UNPAID" : "",
        });
        const response = await fetchApi("SalaryCalculationSettings/rules", "GET", "", params.toString());
        if (response) {
            setSalaryRule(response || null);
        }
    };

    const loadSalarySlabWithouPf = async () => {
        if (!candidateDetail) return;
        const response = await fetchApi("SalaryCalculationSettings/GetSalarySlabBranchWise", "GET", '', `branch_Id=${candidateDetail.branch_Id}`)
        if (response) {
            setSalarySlabRule(response)
        }
    }

    useEffect(() => {
        LoadEmploymentType();
        LoadShiftType();
        loadSalarySlabWithouPf();
    }, [])

    useEffect(() => {
        loadRules();
    }, [employement_Type, intern_Payment_Type]);


    useEffect(() => {
        const subscription = watch((values) => {
            if (!candidateDetail?.email || !candidateDetail?.job_Posting_Id) {
                setLoiContent("");
                return;
            }
            let shift = shiftType.find(f => f.id === values.shift_type);

            const isIntern = values.employement_Type === "INTERN";
            const isPaid = !isIntern || values.intern_Payment_Type === "PAID";

            const content = generateLoiContent({
                name: candidateDetail.candidate_Name,
                gender: candidateDetail.gender,
                company: candidateDetail.payroll_Company_Name,
                jobProfile: candidateDetail.job_profile_Name,
                joiningDate: values.date_Of_joining,
                jobLocation: candidateDetail.branch_Address,
                shift: shift?.shift,
                grossSalary: watch("offered_Salary"),
                basicSalary: watch("basicSalary"),
                employeePF: watch("employeePF"),
                employerPF: watch("employerPF"),
                esicEmployee: watch("esicEmployee"),
                esicEmployer: watch("esicEmployer"),
                netTakeHomeSalary: watch("netTakeHomeSalary"),
                mealAllowance: watch("mealAllowance") ? benfits.meal_Allowance : 0,
                transportAllowance: watch("transportAllowance") ? benfits.transportation_Allowance : 0,
                healthInsurance: watch("healthInsurance") ? benfits.health_Insurance_Coverage : 0,
                monthlyCtc: watch("monthlyCTC"),
                anualCtc: watch("annualCTC"),
                hra: watch("hra"),
                conveyance: watch("conveyance"),
                email: candidateDetail.email,
                jobPostingId: candidateDetail.job_Posting_Id,
                websiteUrl,
                showSalaryBreakup: isPaid,
                stipend: isIntern ? watch("offered_Salary") : 0
            });

            setLoiContent(content);

            const subjectText = isIntern
                ? `${isPaid ? "Paid" : "Unpaid"} Internship Offer - ${candidateDetail?.job_profile_Name}`
                : `Letter of Intent for ${candidateDetail?.candidate_Name} - ${candidateDetail?.job_profile_Name}`;

            if (values.subject !== subjectText) {
                setValue("subject", subjectText, { shouldValidate: true });
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, candidateDetail, shiftType]);


    const generateLoiContent = ({ name, gender, company, jobProfile, joiningDate, jobLocation, shift, grossSalary, basicSalary, employeePF, employerPF, esicEmployee, esicEmployer, netTakeHomeSalary, mealAllowance, transportAllowance, healthInsurance, monthlyCtc, anualCtc, hra, conveyance, email, jobPostingId, websiteUrl, showSalaryBreakup, }: any) => {
        if (!email || !jobPostingId) return "";
        return `
                <p>Dear ${name || "Candidate"},</p>

                <p>Greetings from <strong>${company}</strong>.</p>
                <p>
                This is with reference to our discussion regarding the position of 
                <strong>${jobProfile}</strong> at <strong>${company}</strong>. 
                We are pleased to inform you that we intend to hire you for the said position.
                </p>

                <p>
                We believe that your knowledge, skills, and experience make you well suited for this role.
                ${company} is delighted to welcome you onboard and looks forward to your contribution in supporting
                the organization’s continued growth and success.
                </p>

                <p>
                You are hereby appointed as a <strong>${jobProfile}</strong> on a full-time basis with
                <strong>${company}</strong>. Your appointment shall be subject to an initial probation
                period of <strong>three (3) months</strong>.
                </p>

                <p>
                Your date of joining will be <strong>${joiningDate}</strong>, and your place of work will be
                <strong>${jobLocation}</strong>. Your working hours will be from
                <strong>${shift} (IST)</strong>, or such other hours as may be required in accordance
                with business requirements.
                </p>

                  ${showSalaryBreakup
                ? `
                <hr/>

                <h3>CTC & Salary Breakup Calculator</h3>
                <table border="1" cellpadding="6" cellspacing="0" width="100%">
                <tr><th align="left">Particulars</th><th align="left">Monthly(₹)</th><th align="right">Annual(₹)</th></tr>
                <tr><td>Gross Salary</td><td align="right">${grossSalary}</td><td align="right">${grossSalary * 12}</td></tr>
                <tr><td>Employer PF</td><td align="right">${employerPF}</td><td align="right">${employerPF * 12}</td></tr>
                <tr><td>Employer ESIC</td><td align="right">${esicEmployer || 0}</td><td align="right">${esicEmployer ? esicEmployer * 12 : 0}</td></tr>
                <tr><td>Company Benefits Cost</td><td align="right">${mealAllowance + transportAllowance + healthInsurance}</td><td align="right">${(mealAllowance + transportAllowance + healthInsurance) * 12}</td></tr>
                <tr><td>Total CTC</td><td align="right">${monthlyCtc}</td><td align="right">${anualCtc}</td></tr>  
                <tr><td>Basic Salary</td><td align="right">${basicSalary}</td><td align="right">${basicSalary * 12}</td></tr>  
                <tr><td>HRA</td><td align="right">${hra}</td><td align="right">${hra * 12}</td></tr>
                <tr><td>Conveyance</td><td align="right">${conveyance}</td><td align="right">${conveyance * 12}</td></tr> 
                <tr><td>Employee PF</td><td align="right">${employeePF}</td><td align="right">${employeePF * 12}</td></tr>  
                <tr><td>Employee ESIC</td><td align="right">${esicEmployee}</td><td align="right">${esicEmployee * 12}</td></tr>  
                <tr><td>Net Salary</td><td align="right">${netTakeHomeSalary}</td><td align="right">${netTakeHomeSalary * 12}</td></tr>  
                </table>`
                : `<p> This is an <strong> Unpaid Internship</strong> intended purely for learning and skill development.
                  No stipend, salary, or statutory benefits are applicable.</p>`}
                <br/>
                <br/>
                <hr/>

                <h4>Important Notes</h4>
                <ul>
                <li>Provident Fund (PF) contribution is applicable only if the employee opts for the same.</li>
                <li>ESIC contribution is mandatory as per statutory requirements.</li>
                <li>Net salary may vary slightly due to statutory changes.</li>
                <li>
                It is mandatory that your Aadhaar and PAN are linked. If these documents are not linked,
                the joining process cannot be completed. Kindly ensure compliance prior to your joining date.
                </li>
                </ul>

                <h4>Documents Required at the Time of Joining</h4>
                <ul>
                <li>Photocopies of all relevant certificates / degrees / mark sheets</li>
                <li>Proof of Birth (Matriculation Certificate)</li>
                <li>Photocopy of Passport or Aadhaar Card and PAN Card</li>
                <li>Three recent passport-size photographs</li>
                <li>Appointment Letter from the last organization</li>
                <li>Last three months’ salary slips</li>
                <li>Experience / Relieving Letter from the last organization</li>
               <li>A blank or cancelled cheque is required for salary account verification and processing.</li>
                </ul>

                <p>
                We congratulate you on your appointment and wish you all the very best for a successful
                career with <strong>${company}</strong>.
                </p>

                <p>
                <a href="${websiteUrl}otp-verification?email=${encodeURIComponent(email)}&job=${btoa(String(jobPostingId))}"
                target="_blank">
                Click here to fill your details
                </a>
                </p>

                <p>
                Warm regards,<br/>
                <strong>HR Department</strong><br/>
                ${company}
                </p>
                `;
    };

    const loadBenfit = async () => {
        const response = await fetchApi("DropDown/benefitList", "GET", null, `branch_Id=${candidateDetail?.branch_Id || 0}`);
        if (response) setBenfits(response);

    }
    useEffect(() => {
        loadBenfit();
    }, [])

    const grossSalary = watch("offered_Salary");
    const mealChecked = watch("mealAllowance");
    const transportChecked = watch("transportAllowance");
    const healthChecked = watch("healthInsurance");

    useEffect(() => {
        if (employement_Type === "INTERN") applyInternSalary(watch("offered_Salary"));
        else calculateSalary(watch("offered_Salary"));
    }, [mealChecked, transportChecked, healthChecked, employement_Type]);

    const calculateSalary = (gross?: number) => {
        if (!gross || !salaryRule) return null;
        const { basic_Percentage, min_Basic, min_Gross_Salary, pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap, esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage, hrA_Percentage, conveyance_Percentage } = salaryRule;

        if (gross < min_Gross_Salary) return null;

        let basicSalary: number;

        if (gross >= min_Basic) {
            basicSalary = Math.round((gross * basic_Percentage) / 100);
            if (basicSalary < min_Basic) basicSalary = min_Basic;
        } else {
            basicSalary = Math.round(gross);
        }

        const pfBasic = Math.min(basicSalary, pF_Wage_Cap);
        let employeePF = 0;
        let employerPF = 0;

        if (includePF) {
            employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
            employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
        }

        if (salarySlabRule) {
            if (gross >= salarySlabRule?.salary_From && gross < salarySlabRule?.salary_To && includePF === false) {
                basicSalary = salarySlabRule.minimum_Baisc;
            }
        }

        // ---- ESIC ----
        const isEligibleForESIC = gross <= esiC_Wage_Limit;
        const esicToggleOn = includeESIC;
        const isESICApplicable = isEligibleForESIC && esicToggleOn;

        const esicEmployee = isESICApplicable ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
        const esicEmployer = isESICApplicable ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;
        // ---- /ESIC ----

        const remaining = gross - basicSalary;
        let hra = 0;
        let conveyance = 0;

        if (remaining > 0) {
            hra = Math.round((gross * hrA_Percentage) / 100);
            conveyance = Math.round((gross * conveyance_Percentage) / 100);
            if (hra > remaining) {
                hra = remaining;
                conveyance = 0;
            } else {
                conveyance = remaining - hra;
            }
        }

        const mealAllowance = mealChecked ? benfits?.meal_Allowance ?? 0 : 0;
        const transportAllowance = transportChecked ? benfits?.transportation_Allowance ?? 0 : 0;
        const healthInsurance = gross > esiC_Wage_Limit && healthChecked ? benfits?.health_Insurance_Coverage ?? 0 : 0;

        const monthlyCTC = gross + employerPF + esicEmployer + mealAllowance + transportAllowance + healthInsurance;
        const netTakeHomeSalary = gross - (employeePF + esicEmployee);

        return { basicSalary, basicSalaryForPf: pfBasic, employeePF, employerPF, esicEmployee, esicEmployer, hra, conveyance, monthlyCTC, annualCTC: monthlyCTC * 12, netTakeHomeSalary, esicApplicable: isEligibleForESIC };
    };

    const applyInternSalary = (gross?: number) => {
        if (!gross || !salaryRule) return;

        const { basic_Percentage, min_Basic, pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap, esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage, hrA_Percentage, conveyance_Percentage } = salaryRule;

        let basic = (gross * basic_Percentage) / 100;
        if (basic < min_Basic) basic = min_Basic;

        const basicSalary = Math.round(basic);

        const pfBasic = Math.min(basicSalary, pF_Wage_Cap);


        let employeePF = 0;
        let employerPF = 0;

        if (includePF) {

            employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
            employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
        }

        const isEligibleForESIC = gross <= esiC_Wage_Limit;
        const isESICApplicable = isEligibleForESIC && includeESIC;
        const esicEmployee = isESICApplicable ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
        const esicEmployer = isESICApplicable ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;


        const mealAllowance = mealChecked ? benfits?.meal_Allowance ?? 0 : 0;
        const transportAllowance = transportChecked ? benfits?.transportation_Allowance ?? 0 : 0;
        const healthInsurance = gross > esiC_Wage_Limit && healthChecked ? benfits?.health_Insurance_Coverage ?? 0 : 0;

        const monthlyCTC = gross + employerPF + esicEmployer + mealAllowance + transportAllowance + healthInsurance;
        const netTakeHomeSalary = gross - (employeePF + esicEmployee);

        const remaining = gross - basicSalary;
        const hra = Math.round((remaining * hrA_Percentage) / 100);
        const conveyance = Math.round((remaining * conveyance_Percentage) / 100);

        setValue("basicSalary", basicSalary);
        setValue("basicSalaryForPf", pfBasic);

        setValue("employeePF", employeePF);
        setValue("employerPF", employerPF);

        setValue("esicEmployee", esicEmployee);
        setValue("esicEmployer", esicEmployer);
        setValue("esicApplicable", isEligibleForESIC);
        setValue("hra", hra);
        setValue("conveyance", conveyance);

        setValue("monthlyCTC", monthlyCTC);
        setValue("annualCTC", monthlyCTC * 12);
        setValue("netTakeHomeSalary", netTakeHomeSalary);

        setValue("mealAllowance", mealAllowance);
        setValue("transportAllowance", transportAllowance);
        setValue("healthInsurance", healthInsurance);
    };

    useEffect(() => {
        if (!grossSalary) return;
        if (grossSalary < salaryRule?.pf_Deduction_Threshold) {
            setIncludePF(true);
        }
    }, [grossSalary]);


    useEffect(() => {
        if (employement_Type === "INTERN") {
            if (intern_Payment_Type === "UNPAID") {
                resetSalaryCalculation();
                return;
            }
            if (intern_Payment_Type === "PAID") {
                applyInternSalary(Number(grossSalary));
                return;
            }
        }

        if (!grossSalary || !salaryRule) {
            resetSalaryCalculation();
            return;
        }

        const result = calculateSalary(Number(grossSalary));
        if (!result) return;

        setValue("basicSalary", result.basicSalary);
        setValue("basicSalaryForPf", result.basicSalaryForPf);
        setValue("employeePF", result.employeePF);
        setValue("employerPF", result.employerPF);
        setValue("esicEmployee", result.esicEmployee);
        setValue("esicEmployer", result.esicEmployer);
        setValue("hra", result.hra);
        setValue("conveyance", result.conveyance);
        setValue("monthlyCTC", result.monthlyCTC);
        setValue("annualCTC", result.annualCTC);
        setValue("netTakeHomeSalary", result.netTakeHomeSalary);
        setValue("esicApplicable", result.esicApplicable);

    }, [grossSalary, salaryRule, employement_Type, intern_Payment_Type, mealChecked, transportChecked, healthChecked, includePF, includeESIC]);

    const resetSalaryCalculation = () => {
        setValue("basicSalary", 0);
        setValue("basicSalaryForPf", 0);
        setValue("employeePF", 0);
        setValue("employerPF", 0);
        setValue("esicEmployee", 0);
        setValue("esicEmployer", 0);
        setValue("monthlyCTC", 0);
        setValue("annualCTC", 0);
        setValue("netTakeHomeSalary", 0);
        setValue("hra", 0);
        setValue("conveyance", 0);
        setValue("esicApplicable", false);
        setValue("mealAllowance", 0);
        setValue("transportAllowance", 0);
        setValue("healthInsurance", 0);
    };


    const getPercentage = (value?: number) => {
        const gross = Number(watch("offered_Salary"));
        if (!gross || !value) return "";
        const percentage = ((Number(value) / gross) * 100).toFixed(2);
        return `(${parseFloat(percentage)}%)`;
    };



    const shouldDisableSalaryFields = (employement_Type === "INTERN" && intern_Payment_Type === "UNPAID") || !salaryRule;

    const handleInternAlertClose = () => {
        setValue("offered_Salary", 0);
        resetSalaryCalculation();
        setAlertConfig(null);
    };


    useEffect(() => {
        const gross = Number(watch("offered_Salary"));

        if (employement_Type === "EMPLOYEE" && salaryRule && gross > 0 && gross < Number(salaryRule.min_Gross_Salary)) {
            setAlertConfig({
                colorScheme: "orange",
                description: `The minimum Gross Salary configured is ₹${salaryRule.min_Gross_Salary}.
    You entered Gross Salary ₹${gross}.
    
    Do you want to convert this employee to a Paid Intern?`,
                onConfirm: () => {
                    setValue("employement_Type", "INTERN");
                    setValue("intern_Payment_Type", "PAID");
                },
            });
        }
    }, [salaryRule]);



    return (
        <MyDiv>
            {isSuccess ? (
                <Box textAlign="center" p={6}>
                    <Lottie animationData={SuccessAnimation} loop={false} style={{ height: 150 }} />
                    <Text mt={3} className="font-poppins text_md text_semibold" color="green.600">LOI Sent Successfully 🎉</Text>
                </Box>
            ) : (
                <>
                    <ModalHeader textAlign="center" className="font-poppins text_medium text_xl">Send Letter Of Intent</ModalHeader>
                    <ModalCloseButton />
                    <Divider />
                    <ModalBody>
                        <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={2} >
                            <Box w="100%">
                                <FormLabel>Employment Type</FormLabel>
                                <Controller name="employement_Type" control={control}
                                    render={({ field }) => (
                                        <Select {...field} className="chakra-input">
                                            <option value="EMPLOYEE">Employee</option>
                                            <option value="INTERN">Intern</option>
                                        </Select>
                                    )}
                                />
                            </Box>
                            {watch("employement_Type") === "INTERN" && (
                                <Box w="100%">
                                    <FormLabel>Intern Payment Type</FormLabel>
                                    <Controller name="intern_Payment_Type" control={control}
                                        render={({ field }) => (
                                            <Select {...field} className="chakra-input">
                                                <option value="">Select Intern Type</option>
                                                <option value="PAID">Paid Intern</option>
                                                <option value="UNPAID">Unpaid Intern</option>
                                            </Select>
                                        )}
                                    />
                                </Box>
                            )}
                            <HrlenseInput isRequired type="date" name="date_Of_joining" label="Joining Date" control={control} placeholder="Enter Date of joining" errors={errors} />
                            <Dropdown isRequired name="selection_Term" label="Job Type" control={control} errors={errors} options={employementType} valueKey="id" labelKey="selection_Term" />
                            <Dropdown isRequired name="shift_type" label="Shift Type" control={control} errors={errors} options={shiftType} valueKey="id" labelKey="shift" />
                            <Box>
                                <FormLabel>{employement_Type === "INTERN" ? "Monthly Stipend" : "Gross Salary (Monthly)"}</FormLabel>
                                <Controller name="offered_Salary" control={control} render={({ field }) => (
                                    <Input {...field} type="number" placeholder={employement_Type === "INTERN" ? "Monthly Stipend" : "Gross Salary (Monthly)"} isDisabled={shouldDisableSalaryFields}
                                        onBlur={(e) => {
                                            field.onBlur();
                                            const gross = Number(e.target.value);
                                            if (salaryRule && employement_Type === "EMPLOYEE" && gross > 0 && gross < Number(salaryRule.min_Gross_Salary)) {
                                                setAlertConfig({
                                                    colorScheme: "orange",
                                                    description: `The minimum gross Salary configured is ₹${salaryRule.min_Gross_Salary}.  You entered Gross Salary ₹${gross}.  Do you want to convert this candidate to a Paid Intern?`,
                                                    onConfirm: () => {
                                                        setValue("employement_Type", "INTERN");
                                                        setValue("intern_Payment_Type", "PAID");
                                                        const gross = Number(watch("offered_Salary"));

                                                        setTimeout(() => {
                                                            applyInternSalary(gross);
                                                        }, 0);
                                                    }
                                                });
                                            }
                                        }}
                                    />
                                )}
                                />
                                {errors.offered_Salary && (<Text color="red.500" fontSize="12px" mt={1}>{errors.offered_Salary.message}</Text>)}
                            </Box>


                            <Checkbox isChecked={includePF} onChange={(e) => setIncludePF(e.target.checked)} isDisabled={!grossSalary || grossSalary < salaryRule?.pf_Deduction_Threshold}>Include PF</Checkbox>

                            {salaryRule?.is_ESIC_Required && grossSalary  && grossSalary > 0 && grossSalary <= salaryRule?.esiC_Wage_Limit && (
                                <Checkbox
                                    isChecked={includeESIC}
                                    onChange={(e) => setIncludeESIC(e.target.checked)}
                                    isDisabled={!grossSalary}
                                >
                                    Include ESIC
                                </Checkbox>
                            )}

                            <Controller name="mealAllowance" control={control} render={({ field }) => (<Checkbox disabled={shouldDisableSalaryFields || !grossSalary} {...field} > Meal Allowance{benfits?.meal_Allowance ? ` ₹(${benfits?.meal_Allowance})` : ''} </Checkbox>)} />
                            <Controller name="transportAllowance" control={control} render={({ field }) => (<Checkbox disabled={shouldDisableSalaryFields || !grossSalary} {...field}  > Transport Allowance{benfits?.transportation_Allowance ? ` ₹(${benfits?.transportation_Allowance})` : ''} </Checkbox>)} />
                            {grossSalary && grossSalary > salaryRule?.esiC_Wage_Limit && <Controller name="healthInsurance" control={control} render={({ field }) => (<Checkbox disabled={shouldDisableSalaryFields || !grossSalary} {...field}  > Health Insurance{benfits?.health_Insurance_Coverage ? ` ₹(${benfits?.health_Insurance_Coverage})` : ''} </Checkbox>)} />}


                            <HrlenseInput disable={shouldDisableSalaryFields} name="basicSalary" label={`Basic Salary ${getPercentage(watch("basicSalary"))}`} control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="basicSalaryForPf" label="Basic salary for PF" type="number" control={control} placeholder="Enter PF Basic" readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="employeePF" label={`Employee PF (12%)`} control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="employerPF" label={`Employer PF (12%)`} control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="esicEmployee" label={`Employee ESIC ${getPercentage(watch("esicEmployee"))}`} control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="esicEmployer" label={`Employer ESIC ${getPercentage(watch("esicEmployer"))}`} control={control} readOnly />
                            <HrlenseInput isRequired disable={shouldDisableSalaryFields} name="hra" label={`HRA ${getPercentage(watch("hra"))}`} control={control} errors={errors} readOnly />
                            <HrlenseInput isRequired disable={shouldDisableSalaryFields} name="conveyance" label={`Conveyance ${getPercentage(watch("conveyance"))}`} control={control} errors={errors} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="monthlyCTC" label="Monthly CTC" control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="annualCTC" label="Annual CTC" control={control} readOnly />
                            <HrlenseInput disable={shouldDisableSalaryFields} name="netTakeHomeSalary" label="Net Salary" control={control} readOnly />
                        </Grid>
                        <HrlenseInput isRequired disable={shouldDisableSalaryFields} name="subject" label="Subject" control={control} placeholder="Enter Subject" errors={errors} />
                        <FormControl mt={3}>
                            <Text className="font-poppins text_regular text_medium">LOI</Text>
                            <SunEditor
                                height="280px"
                                setContents={loiContent}
                                placeholder="Enter Job Summary"
                                setOptions={{
                                    buttonList: [
                                        ["undo", "redo"],
                                        ["bold", "italic", "underline", "strike"],
                                        ["list", "align", "fontSize", "formatBlock"],
                                        ["link", "image", "video"],
                                        ["removeFormat"],
                                    ],
                                }}
                                onChange={(content: string) => setLoiContent(content)}
                            />
                        </FormControl>
                        <Flex justify="flex-end" mt={2}>
                            <Button title="Send" className="btn font-poppins text_sm text_medium" rightIcon={loading ? undefined : <Image src={ArrowRight} />} onClick={handleSubmit(sendLoi)} isLoading={loading} loadingText="Sending..." colorScheme="green">Send</Button>
                        </Flex>
                    </ModalBody>
                </>
            )}

            <AlertCard title="Minimum Salary Validation" isOpen={!!alertConfig} onClose={handleInternAlertClose}
                onConfirm={() => {
                    if (alertConfig?.onConfirm) {
                        alertConfig.onConfirm();
                    }
                    setAlertConfig(null);
                }} description={alertConfig?.description || ""} colorScheme={alertConfig?.colorScheme || "orange"} />

        </MyDiv>
    );
};

export default LOICard;